import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import BulkAssemblyConstructsTabState from 'molbio/bulk-assembly/backbone/BulkAssemblyConstructsTabState';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import BulkAssemblyConstructsTab from '../constructs-tab/BulkAssemblyConstructsTab';

export default class BulkAssemblyConstructsTabView extends BufferTabView<BulkAssemblyConstructsTabState> {
  render(): this {
    const {id} = this.model.bulkAssemblyModel().getBulkAssembly();
    renderToDOM(<BulkAssemblyConstructsTab assemblyId={id} />, this.el);
    return this;
  }

  remove(): this {
    ReactDOM.unmountComponentAtNode(this.el);
    super.remove();
    return this;
  }
}
